/**
 * LoadingSpinner Component
 * 
 * Material Tailwind spinner for async operations.
 * Task: T053
 * 
 * Props:
 * - size: 'sm' | 'md' | 'lg' (default: 'md')
 * - message: Optional loading message
 */

import React from 'react';
import { Spinner, Typography } from '@material-tailwind/react';

const LoadingSpinner = ({ size = 'md', message }) => {
  // Map size prop to Material Tailwind size classes
  const sizeClasses = {
    sm: 'h-8 w-8',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
  };
  
  return (
    <div className="flex flex-col items-center justify-center p-8">
      <Spinner className={sizeClasses[size] || sizeClasses.md} color="purple" />
      {message && (
        <Typography
          variant="paragraph"
          color="blue-gray"
          className="mt-4 text-center"
        >
          {message}
        </Typography>
      )}
    </div>
  );
};

export default LoadingSpinner;
